import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import close from '../../assets/design/pricing/closing-x.png';
import calendar from '../../assets/design/dashboard/calendar.png';
import { Link, useNavigate } from 'react-router-dom';
import { isAuthed } from '../../services/auth.service';
import { getAvailableSellersAll, addUserEventTracking, addCompanyClick, createSellerDemo, getUserProfile, hasAvailableApplications, getAvailableOffers, companyOfferUse } from '../../utils/api';
import { Gift, Video, Star } from 'lucide-react';
import QualifierQuestions from '../../components/qualifier/QualifierQuestions';
import AvailableTimes from '../../components/qualifier/AvailableTimes';
import SubmitTimes from '../../components/qualifier/SubmitTimes';
import FadeIn from '../../utils/fadein';
import Share from '../search/Share';
import { FaCheckCircle, FaTimes, FaCheck } from 'react-icons/fa';
import { BadgeDollarSign, Link2, PenIcon, Ticket, InfoIcon } from 'lucide-react';
import { Spinner } from '@chakra-ui/react';

const Deals = () => {
  const navigate = useNavigate();
  const [results, setResults] = useState([]);
  const [bookingLoading, setBookingLoading] = useState(false);
  const [currentDemo, setCurrentDemo] = useState(null);
  const [currentDemoId, setCurrentDemoId] = useState(null);
  const [showQualifier, setShowQualifier] = useState(false);
  const [showAdvice, setShowAdvice] = useState(false);
  const [showMaxReached, setShowMaxReached] = useState(false);
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);
  const [adviceType, setAdviceType] = useState(null);
  const [hasAvailable, setHasAvailable] = useState(false);
  const [showHasNoCompany, setShowHasNoCompany] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [hasCompany, setHasCompany] = useState(false);
  const [currentCompanyId, setCurrentCompanyId] = useState(null);
  const [showHasApplied, setShowHasApplied] = useState(false);
  const [showUnverified, setShowUnverified] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [qualifierCompleted, setQualifierCompleted] = useState(false);
  const [showSelectedTime, setShowSelectedTime] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showShare, setShowShare] = useState(false);
  const [showExclusiveDeal, setShowExclusiveDeal] = useState(false);
  const [companyOffer, setCompanyOffer] = useState(null);
  const [dealConfirmed, setDealConfirmed] = useState(false);
  const [company, setCompany] = useState(null);
  const [acceptedTerms, setAcceptedTerms] = useState(true);
  const [isDealLoading, setIsDealLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [expandedDescriptions, setExpandedDescriptions] = useState({});

  const imageUrl = process.env.REACT_APP_IMAGE_URL;

   async function fetchData() {
      setLoading(true); // Set loading to true before fetch
      const response = await getAvailableOffers();
      if (response.success) {
        setResults(response.data);
      }
      setLoading(false);
    }

  useEffect(() => {
    if (isAuthed()) {
      setIsLoggedIn(true);
    }
  }, []);

  useEffect(() => {
    async function fetchData() {
      setLoading(true); // Set loading to true before fetch
      const response = await getAvailableOffers();
      if (response.success) {
        setResults(response.data);
      }
      setLoading(false);
    }

    async function loadUserProfile() {
      let res = await getUserProfile();

      console.log(res.data);

      if (res.success) {
        let _user = res.data;

        if (_user.work_email_verified) {
          setIsVerified(true);
        }

        else {
          setIsVerified(false);
        }

        if (_user.company_id != null) {
          setHasCompany(true);
        }
      }
    }
    loadUserProfile();
    fetchData();
  }, []);

  function demoAccepted() {
    let _filter = results.filter(item => item.company_id !== selectedCompanyId);
    setResults(_filter);
  }

  async function handleQualifierClick(demo_id, item) {
    console.log(demo_id, item);
    setSelectedCompanyId(item.company_id);
    if (isLoggedIn === false) {
      setAdviceType('RequestDemo');
      setShowAdvice(true);
      setBookingLoading(false);
      return;
    }

    if (hasCompany === false) {
      console.log("no company info found");
      setShowHasNoCompany(true);
      return;
    }

    setBookingLoading(true);
    setSelectedCompanyId(item.company_id);
    setCurrentCompanyId(item.company_id);

    let _check = await hasAvailableApplications();

    if (_check.success) {
      if (_check.data === true) {
        setShowMaxReached(false);
        setHasAvailable(true);
      }

      else {
        setHasAvailable(false);
        setShowMaxReached(true);
        setBookingLoading(false);
        return;
      }
    }

    if (demo_id === null) {
      let data = { seller_id: item.seller_id };
      let _res = await createSellerDemo(data);

      if (_res.success) {
        setCurrentDemo(item);
        setCurrentDemoId(_res.data);
        setShowQualifier(true);
      }

      else {
        if (_res.has_applied != null && _res.has_applied === true) {
          setShowHasApplied(true);
          // alert("Looks like you have already applied to this company in the past. We only allow 1 application per company per user currently.")
        }

        else {
          setCurrentDemo(item);
          setCurrentDemoId(_res.demo_id);
          setShowQualifier(true);
        }
      }

      setBookingLoading(false);
    }

    else {
      setCurrentDemo(item);
      setCurrentDemoId(demo_id);
      setShowQualifier(true);
      setBookingLoading(false);
    }

    await addUserEventTracking('Book demo click', demo_id);
    await addCompanyClick(item.company_id, 'Discover software');
  }

  async function handleDealConfirmed() {
        let res = await companyOfferUse(company.company_offer_id);

    if (res.success) {
      setIsDealLoading(true);
      setDealConfirmed(true);
      fetchData();
    }
  }

  const handleShowExclusiveDeal = async (solution) => {

      setShowExclusiveDeal(true);
      setDealConfirmed(false);
      setAcceptedTerms(true);
      setIsDealLoading(false);
      setCompany(solution);

  };

  const handleShowActivatedDeal = (solution) => {
    setShowExclusiveDeal(true);
    setDealConfirmed(true); // Show details immediately
    setIsDealLoading(false);
    setCompany(solution);
  };

  const toggleDescription = (id) => {
    setExpandedDescriptions(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const renderSolutionCard = (solution) => (
    <div key={solution.id} className="h-full flex flex-col border rounded-lg shadow-sm hover:shadow-lg transition-shadow bg-white">
      <div className="p-6 pb-2">
        <div className="flex items-center gap-3 mb-2">
          <div className={`${solution.logoColor} text-white h-9 w-9 rounded-full flex items-center justify-center mr-1 flex-shrink-0`}>
            <img src={imageUrl + 'tr:di-@@companylogos@@default-buyer.png/' + solution.logo} alt={solution.name} className="h-8 w-8 rounded-full" />
          </div>
          <div>
            <h3 className="text-lg font-semibold">{solution.name}</h3>
            <p className="text-sm text-gray-500">{solution.industry_name}</p>

          </div>
        </div>

        <div className="flex flex-wrap gap-1 mt-1">
          {solution.is_seller && (
            <span className="inline-flex items-center gap-1 text-xs font-semibold px-2.5 py-0.5 rounded-full bg-blue-50 text-blue-600 border border-blue-100">
              <Video className="h-3 w-3" /> Demo Available
            </span>
          )}
          {solution.has_offer && (
            <span className="inline-flex items-center gap-1 text-xs font-semibold px-2.5 py-0.5 rounded-full bg-green-50 text-green-600 border border-green-100">
              <Gift className="h-3 w-3" /> Exclusive Offer
            </span>
          )}
          {solution.is_featured && (
            <span className="inline-flex items-center gap-1 text-xs font-semibold px-2.5 py-0.5 rounded-full bg-amber-50 text-amber-600 border border-amber-100">
              <Star className="h-3 w-3" /> Featured
            </span>
          )}
        </div>
      </div>

      <div className="px-6 py-3 flex-grow">
        <p className="text-sm text-gray-600">
          {expandedDescriptions[solution.id] || solution.description.length <= 150
            ? solution.description
            : solution.description.slice(0, 150) + '...'}
          {solution.description.length > 150 && (
            <button
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                toggleDescription(solution.id);
              }}
              className="ml-1 text-purple-600 hover:text-purple-700 font-medium"
            >
              {expandedDescriptions[solution.id] ? 'Read less' : 'Read more'}
            </button>
          )}
        </p>

        {solution.has_offer && (
          <div className="bg-gradient-to-r from-green-50 to-emerald-50 px-4 py-3 rounded-lg mt-4 border border-green-100">
            <p className="text-xs font-semibold text-green-600 uppercase tracking-wide mb-1">Exclusive offer</p>
            <p className="text-lg font-bold text-gray-900">{solution.offer_name}</p>
            <p className="text-sm text-green-700 mt-1">
              <span className="inline-flex items-center">
                <Gift className="h-4 w-4 mr-1" />
                Unlock this special deal now
              </span>
            </p>
          </div>
        )}
      </div>

      <div className="px-6 pb-6 pt-0 mt-3">
        <div className="flex items-center gap-2 w-full">
          {isAuthed() ? (
            solution.offer_activated ? (
              <button
                onClick={() => handleShowActivatedDeal(solution)}
                className="flex-1 inline-flex items-center justify-center rounded-lg bg-green-50 px-4 py-2.5 text-sm font-medium text-green-700 border border-green-100 hover:bg-green-100 transition-colors"
              >
                <FaCheckCircle className="h-4 w-4 mr-2" />
                View Deal Details
              </button>
            ) : (
              <button
                onClick={() => handleShowExclusiveDeal(solution)}
                className="flex-1 inline-flex items-center justify-center rounded-lg bg-gradient-to-r from-purple-400 to-fuchsia-500 px-4 py-2.5 text-sm font-medium text-white shadow-sm hover:from-purple-500 hover:to-fuchsia-600 transition-all duration-150 transform hover:scale-[1.02]"
              >
                <Gift className="h-4 w-4 mr-2" />
                Unlock Deal
              </button>
            )
          ) : (
            <Link
              to="/join-now"
              className="flex-1 inline-flex items-center justify-center rounded-lg bg-gradient-to-r from-purple-400 to-fuchsia-500 px-4 py-2.5 text-sm font-medium text-white shadow-sm hover:from-purple-500 hover:to-fuchsia-600 transition-all duration-150 transform hover:scale-[1.02]"
            >
              <Gift className="h-4 w-4 mr-2" />
              Unlock Deal
            </Link>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <>
      <Helmet>
        <title>Exclusive Software Deals & Offers | LeadR</title>
        <meta name="description" content="Discover exclusive deals and special offers on top software solutions. Access limited-time discounts and promotions for business software and tools." />
      </Helmet>

      <div className="bg-gradient-to-b from-purple-50 to-white">
        <div className="container mx-auto px-4 max-w-7xl pt-16 pb-20 text-center lg:pt-24">
          <h1 className="mx-auto max-w-4xl font-display text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">
            Exclusive Software Deals
            <span className="text-purple-600"> for Your Business</span>
          </h1>
          
          <p className="mx-auto mt-6 max-w-2xl text-lg text-gray-600">
            Access special discounts and promotional offers on premium software solutions. 
            Save money while discovering the perfect tools for your business.
          </p>
          
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-3xl">
              <div className="flex flex-col items-center p-4">
                <Gift className="h-8 w-8 text-purple-600 mb-2" />
                <h3 className="text-lg font-semibold text-gray-900">Exclusive Offers</h3>
                <p className="text-sm text-gray-600 text-center">Special discounts on premium software solutions</p>
              </div>
              
              <div className="flex flex-col items-center p-4">
                <BadgeDollarSign className="h-8 w-8 text-purple-600 mb-2" />
                <h3 className="text-lg font-semibold text-gray-900">Save Money</h3>
                <p className="text-sm text-gray-600 text-center">Get the best prices on top business tools</p>
              </div>
              
              <div className="flex flex-col items-center p-4">
                <Star className="h-8 w-8 text-purple-600 mb-2" />
                <h3 className="text-lg font-semibold text-gray-900">Vetted Solutions</h3>
                <p className="text-sm text-gray-600 text-center">Hand-picked selection of quality software</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {loading ? (
        <div className="flex items-center justify-center min-h-[400px]">
          <div className="">
            <Spinner />
          </div>
        </div>
      ) : (
        <div>
          {/* Only show if there are offers available */}
          {results.some(solution => solution.has_offer) && (
            <div className="">
              <div className="container mx-auto px-4 max-w-7xl">

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {results
                    .filter(solution => solution.has_offer)
                    .map(renderSolutionCard)}
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {showSelectedTime && (
        <div className='overlay'>
          <div className='modal modal--pad0 modal--wide' style={{ overflow: 'auto' }}>
            {currentDemo.booking_style === 'daily_view' && (
              <AvailableTimes demo={currentDemo} demo_id={currentDemoId} company_name={currentDemo.company_name} seller_id={currentDemo.seller_id} setShowSelectedTime={setShowSelectedTime} showSteps={false} setShowConfirmation={setShowConfirmation} demoAccepted={demoAccepted} />
            )}

            {currentDemo.booking_style === 'list_view' && (
              <SubmitTimes demo={currentDemo} demo_id={currentDemoId} company_name={currentDemo.company_name} seller_id={currentDemo.seller_id} setShowSelectedTime={setShowSelectedTime} showSteps={false} setShowConfirmation={setShowConfirmation} demoAccepted={demoAccepted} />
            )}
          </div>
        </div>
      )}

      {showShare && (
        <div className="overlay">
          <FadeIn duration={250} delay={250}>
            <Share setShow={setShowShare} />
          </FadeIn>
        </div>
      )}

      {showConfirmation && (
        <>
          <div className='overlay'></div>
          <div className='modal'>
            <div className='modal__close' onClick={() => setShowConfirmation(false)}>
              <FaTimes />
            </div>

            <div className='center' style={{ fontSize: "50px", marginBottom: "20px", color: 'mediumseagreen' }}>
              <FaCheckCircle />
            </div>

            <div>Your request is now being reviewed. You should hear back within 24 hours.</div>

            <div>In the meantime, keep your profile up to date and check back daily for more demo opportunities!</div>

            <div className='center mt-20'>
              <button className='btn' onClick={() => setShowConfirmation(false)}>Close</button>
            </div>
          </div>
        </>
      )}

      {showQualifier && (
        <>
          <div className='overlay'></div>
          <div className='modal modal--pad0 modal__qq'>
            <QualifierQuestions currentDemo={currentDemo} demo_id={currentDemoId} setIsCompleted={setQualifierCompleted} setShowQualifier={setShowQualifier} setShowSelectedTime={setShowSelectedTime}></QualifierQuestions>
          </div>
        </>
      )}

      {showExclusiveDeal && (
        <>
          <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 transition-opacity" onClick={() => setShowExclusiveDeal(false)} />
          <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-lg bg-white rounded-xl shadow-2xl z-50 p-6">
            {isAuthed() ? (
              <>
                <div className="flex justify-between items-start mb-6">
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900">Exclusive Deal</h3>
                    <p className="text-sm text-gray-500 mt-1">Special offer for {company?.name}</p>
                  </div>
                  <button onClick={() => setShowExclusiveDeal(false)} className="text-gray-400 hover:text-gray-500">
                    <FaTimes />
                  </button>
                </div>

                <div className="space-y-6">
                  <div className="text-sm text-gray-600 mb-4">
                    {company?.offer_description}
                  </div>


                  {/* Confirm Button */}
                  {!dealConfirmed && (
                    <>
                      {/* Terms Acceptance Checkbox */}
                      {/* <div className="flex items-start space-x-3 pt-4">
                        <input
                          type="checkbox"
                          id="acceptTerms"
                          checked={acceptedTerms}
                          onChange={(e) => setAcceptedTerms(e.target.checked)}
                          className="mt-1"
                        />
                        <label htmlFor="acceptTerms" className="text-sm text-gray-600">
                          I accept the <Link to='/terms'>terms and conditions</Link> of this exclusive offer
                        </label>
                      </div> */}
                      <button
                        onClick={() => handleDealConfirmed()}
                        disabled={!acceptedTerms || isDealLoading}
                        className={`w-full py-3 px-4 rounded-md font-medium transition-colors flex items-center justify-center ${acceptedTerms && !isDealLoading
                          ? 'bg-purple-600 hover:bg-purple-700 text-white'
                          : 'bg-gray-100 text-gray-400 cursor-not-allowed'
                          }`}
                      >
                        {isDealLoading ? (
                          <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                          </svg>
                        ) : (
                          "Confirm & View Redemption Details"
                        )}
                      </button>
                    </>
                  )}

                  {/* Redemption Details (shown after confirmation) */}
                  {dealConfirmed && (
                    <div className="space-y-6 animate-fadeIn">
                      {/* Redemption Instructions */}
                      <div>
                        <h4 className="font-medium text-gray-900 mb-2">
                          <InfoIcon /> How to Redeem</h4>
                        <div className='text-sm text-gray-600 space-y-1'>
                          {company?.how_to_redeem}
                        </div>
                      </div>

                      {/* Redemption URL */}
                      {company?.offer_code && company?.offer_code !== '' && (
                        <div>
                          <h4 className="font-medium text-gray-900 mb-2">
                            <Ticket /> Redemption Code</h4>
                          <div className="text-sm text-gray-600 mb-4">
                            {company?.offer_code}
                          </div>
                        </div>
                      )}

                      {/* Redemption URL */}
                      {company?.offer_url && company?.offer_url !== '' && (
                        <div>
                          <h4 className="font-medium text-gray-900 mb-2">
                            <Link2 /> Redemption URL</h4>
                          <div className="text-sm text-gray-600 mb-4">
                            <a href={company?.offer_url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                              {company?.offer_url}
                            </a>
                          </div>
                        </div>
                      )}

                      {/* Terms & Conditions */}
                      {company?.terms_and_conditions && company?.terms_and_conditions !== '' && (
                        <div>
                          <h4 className="font-medium text-gray-900 mb-2">
                            <PenIcon /> Terms & Conditions</h4>
                          <div className="text-sm text-gray-600 space-y-1">
                            <div>{company?.terms_and_conditions}</div>
                          </div>
                        </div>
                      )}

                      {/* Close Button */}
                    </div>
                  )}
                </div>
              </>
            ) : (
              // Sign up prompt for unauthenticated users
              <>
                <div className="flex justify-between items-start mb-6">
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900">Create an Account to Access</h3>
                    <p className="text-sm text-gray-500 mt-1">Unlock exclusive deals and offers</p>
                  </div>
                  <button onClick={() => setShowExclusiveDeal(false)} className="text-gray-400 hover:text-gray-500">
                    <FaTimes />
                  </button>
                </div>

                <div className="space-y-6">
                  <div className="bg-blue-50 p-4 rounded-lg">
                    <div className="flex items-start">
                      <div className="shrink-0 p-1">
                        <BadgeDollarSign className="h-6 w-6 text-blue-600" />
                      </div>
                      <div className="ml-3">
                        <h4 className="text-blue-800 font-medium">Exclusive Deal Available</h4>
                        <p className="text-sm text-blue-700 mt-1">Create a free account to view and access this exclusive offer from {company?.name}</p>
                      </div>
                    </div>
                  </div>

                  <div className="text-sm text-gray-600">
                    <p className="mb-4">By creating an account you'll get:</p>
                    <ul className="space-y-2">
                      <li className="flex items-center gap-2">
                        <FaCheck className="text-green-500" /> Access to exclusive deals
                      </li>
                      <li className="flex items-center gap-2">
                        <FaCheck className="text-green-500" /> Product recommendations
                      </li>
                      <li className="flex items-center gap-2">
                        <FaCheck className="text-green-500" /> Personalized demo experience
                      </li>
                    </ul>
                  </div>

                  <div className="pt-4 border-t border-gray-200 space-y-3">
                    <button
                      onClick={() => navigate('/join-now')}
                      className="w-full py-3 bg-purple-600 hover:bg-purple-700 text-white rounded-md font-medium transition-colors"
                    >
                      Create Free Account
                    </button>
                    <p className="text-center text-sm text-gray-500">
                      Already have an account?{' '}
                      <button
                        onClick={() => navigate('/login')}
                        className="text-purple-600 hover:text-purple-700 font-medium"
                      >
                        Sign in
                      </button>
                    </p>
                  </div>
                </div>
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default Deals;
